// extracted by mini-css-extract-plugin
export default {"contentBox":"styles_contentBox__cr2K0"};